/**
 * Coups de pouce — Attendu 644 « Effectuer des conversions d'aire ».
 *
 * Une entrée par `generator_key` (cf. gen_644.js). Les 6 formats partagent le
 * même noyau de conversion : une seule fiche, référencée par les 2 clés
 * (conversion_tableau, conversion_directe — chaque clé couvre ses formats).
 * Page 2 : LE geste de classe — le tableau de conversion (2 sous-colonnes par
 * unité), en SVG. Exemple HORS pools : 62,4 (les tirages décimaux du gen
 * s'arrêtent à 9,9 ; les entiers à 50). Pas de calculatrice sur ce gen :
 * le décalage de virgule mental EST la compétence (décision revue 2026-07-31).
 */

// ── Tableau de conversion : 4 unités × 2 sous-colonnes, 62,4 m² → 624 000 cm² ──
// Couleurs EXPLICITES (jamais de currentColor — thème sombre élève).
// Traits épais entre unités, fins entre sous-colonnes ; chiffres en orange.
const SVG_TABLEAU = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 120" width="300" height="113" role="img"
     aria-label="Tableau de conversion : 62,4 mètres carrés égalent 624 000 centimètres carrés">
  <rect x="8" y="10" width="304" height="95" fill="none" stroke="#0f172a" stroke-width="2"/>
  <line x1="8" y1="45" x2="312" y2="45" stroke="#0f172a" stroke-width="2"/>
  <line x1="46" y1="45" x2="46" y2="105" stroke="#94a3b8" stroke-width="1"/>
  <line x1="84" y1="10" x2="84" y2="105" stroke="#0f172a" stroke-width="2"/>
  <line x1="122" y1="45" x2="122" y2="105" stroke="#94a3b8" stroke-width="1"/>
  <line x1="160" y1="10" x2="160" y2="105" stroke="#0f172a" stroke-width="2"/>
  <line x1="198" y1="45" x2="198" y2="105" stroke="#94a3b8" stroke-width="1"/>
  <line x1="236" y1="10" x2="236" y2="105" stroke="#0f172a" stroke-width="2"/>
  <line x1="274" y1="45" x2="274" y2="105" stroke="#94a3b8" stroke-width="1"/>
  <text x="46" y="34" text-anchor="middle" font-size="15" font-weight="bold" fill="#0f172a">m²</text>
  <text x="122" y="34" text-anchor="middle" font-size="15" font-weight="bold" fill="#0f172a">dm²</text>
  <text x="198" y="34" text-anchor="middle" font-size="15" font-weight="bold" fill="#0f172a">cm²</text>
  <text x="274" y="34" text-anchor="middle" font-size="15" font-weight="bold" fill="#0f172a">mm²</text>
  <text x="27" y="85" text-anchor="middle" font-size="19" font-weight="bold" fill="#fb923c">6</text>
  <text x="65" y="85" text-anchor="middle" font-size="19" font-weight="bold" fill="#fb923c">2</text>
  <text x="103" y="85" text-anchor="middle" font-size="19" font-weight="bold" fill="#fb923c">4</text>
  <text x="141" y="85" text-anchor="middle" font-size="19" font-weight="bold" fill="#fb923c">0</text>
  <text x="179" y="85" text-anchor="middle" font-size="19" font-weight="bold" fill="#fb923c">0</text>
  <text x="217" y="85" text-anchor="middle" font-size="19" font-weight="bold" fill="#fb923c">0</text>
</svg>`.trim();

const FICHE_CONVERSION = {
    pages: [
        {
            titre: 'Convertir une aire',
            lignes: [
                // Concret d'abord (retour utilisateur : « × 100, 2 rangs par
                // étage » trop abstrait pour un 6e) : la relation s'ancre sur
                // deux exemples avant la règle de direction.
                'Pour les aires, chaque unité vaut **100 fois** sa voisine plus petite : 1 m² = **100** dm², 1 dm² = **100** cm².',
                'Vers une unité plus **grande** : on **divise**. Vers une unité plus **petite** : on **multiplie**.',
            ],
        },
        {
            titre: 'Avec le tableau',
            lignes: [
                'On veut convertir **62,4 m²** en **cm²**.',
                'Place le chiffre des unités (**2**) dans la colonne de droite de **m²**, un chiffre par case, puis **complète avec des 0** jusqu\'à la colonne de **droite** de cm².',
                'Lis le tableau : 62,4 m² = **624 000 cm²**.',
            ],
            svg: SVG_TABLEAU,
        },
    ],
};

const CP_644 = {
    conversion_tableau_qcm_unique: FICHE_CONVERSION,
    conversion_tableau_texte: FICHE_CONVERSION,
    conversion_tableau_relier: FICHE_CONVERSION,
    conversion_directe_qcm_unique: FICHE_CONVERSION,
    conversion_directe_texte: FICHE_CONVERSION,
    conversion_directe_texte_trou_saisie: FICHE_CONVERSION,
};

export default CP_644;
